import React from "react";
import { Inbox, Loader, CheckCircle2, PackageCheck, Layers } from "lucide-react";

const CARDS = [
  { key: "MASUK", label: "Masuk", icon: Inbox, color: "text-amber-300", ring: "border-amber-400/25", glow: "bg-amber-400/10" },
  { key: "ON PROSES", label: "On Proses", icon: Loader, color: "text-blue-300", ring: "border-blue-400/25", glow: "bg-blue-400/10" },
  { key: "SELESAI", label: "Selesai", icon: CheckCircle2, color: "text-emerald-300", ring: "border-emerald-400/25", glow: "bg-emerald-400/10" },
  { key: "DITERIMA", label: "Diterima", icon: PackageCheck, color: "text-slate-200", ring: "border-slate-400/25", glow: "bg-slate-400/10" },
];

export const StatsCards = ({ stats, active, onSelect }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6" data-testid="stats-cards">
    <button
      data-testid="stat-card-total"
      onClick={() => onSelect?.("ALL")}
      className={`glass lift rounded-2xl p-5 md:p-6 text-left ${
        active === "ALL" ? "border-blue-400/50" : ""
      }`}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.18em] text-slate-400 font-semibold">
          Total JO
        </span>
        <Layers className="w-4 h-4 text-blue-400" />
      </div>
      <div className="mt-4 font-display text-4xl md:text-5xl font-light metal-text" data-testid="stat-value-total">
        {stats?.TOTAL ?? 0}
      </div>
    </button>
    {CARDS.map((c) => (
      <button
        key={c.key}
        data-testid={`stat-card-${c.key.toLowerCase().replace(/\s/g, "-")}`}
        onClick={() => onSelect?.(c.key)}
        className={`glass lift rounded-2xl p-5 md:p-6 text-left ${
          active === c.key ? c.ring.replace("/25", "/60") : ""
        }`}
      >
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-[0.18em] text-slate-400 font-semibold">
            {c.label}
          </span>
          <span className={`w-7 h-7 rounded-lg ${c.glow} flex items-center justify-center`}>
            <c.icon className={`w-4 h-4 ${c.color}`} />
          </span>
        </div>
        <div
          className={`mt-4 font-display text-4xl md:text-5xl font-light ${c.color}`}
          data-testid={`stat-value-${c.key.toLowerCase().replace(/\s/g, "-")}`}
        >
          {stats?.[c.key] ?? 0}
        </div>
      </button>
    ))}
  </div>
);
